import {BUSCAR_RESERVAS_BPE_ITINERARIO} from '../../actions/types'

const initialState = {
    reservasBpe: null
}

export default function reducerBuscarReservasBpeItinerario(state = [], action = initialState) {
    switch (action.type) {
        case BUSCAR_RESERVAS_BPE_ITINERARIO: {
            const reservasBpe = action.payload.data
            if(reservasBpe) {
                return {...state,
                    reservasBpe: reservasBpe
                }
            }
            return []
        }
        default: {
            return state
        }
    }
}